import React from "react";
import { useTheme } from "@mui/material";

import { tss } from 'tss-react';

import styles from "./styles";

export default function Copyright() {
  const theme = useTheme();
  const { classes } = tss.create(styles(theme))();

  const currentYear = () => {
    let dt = new Date();
    return dt.getFullYear();
  }

  return (
    <p className={classes.footer}>
      {`© ${currentYear()} ${theme.variables.host}`}
    </p>
  );
}
